var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgServo = function SvgServo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 12.328 4.793)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4h8ZM4.093 3h-.325v.837H3v.322h.768V5h.325v-.841h.769v-.322h-.769V3Zm7.407.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z",
    fill: "#f29046"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#f29046",
    cx: 4,
    cy: 4,
    r: 3.5
  }))));
};

export default SvgServo;